/* Users module */
import Vue from 'vue';
import Nprogress from 'nprogress';
import router from '@/router';
import axios from 'axios';
import instance from '@/helpers/axios';
import qs from 'qs'

// load api config in your site
import {API_ENDPOINT_URL, MASTER_API_KEY, ADMIN_LOGIN_URL} from '@/config/api_config'

// get token authenticated
const token = localStorage.getItem('token') || null;

const state = {
    role_name: null,
    role_status: false,
    delete_status: false,
    role_info: {},
    role_items: []
}

const getters = {
    role_name: state => {
        return state.role_name
    },
    role_status: state => {
        return state.role_status
    },
    delete_status: state => {
        return state.delete_status
    },
    role_items: state => {
        return state.role_items
    },
}

const actions = {
    createUserRole(context, payload) {
        // const { input_form } =  payload;

        const formData = {
          params: qs.parse({
            ...payload.input_form
          })
        }

        instance.post(`${API_ENDPOINT_URL}roles`, qs.stringify(payload.input_form))
        .then(response => {
            Nprogress.start();

            setTimeout(() => {
                context.commit('UserRoleSuccess',response);
            },1000);
        })
        .catch(error => {
            let error_data = error.response
            if (error_data) {
                context.commit('saveUserRoleFailure', error_data);
            }
        });

    },
    updateUserRole(context,payload) {
        const { input_form } =  payload;

        const formData = {
          params: qs.parse({
            ...payload.input_form
          })
        }

      instance.put(`${API_ENDPOINT_URL}roles/${input_form.id}`, qs.stringify(payload.input_form))
        .then(response => {
            Nprogress.start();
            setTimeout(() => {
                context.commit('UserRoleSuccess',response);
            },1000);
        })
        .catch(error => {
            let error_data = error.response
            if (error_data) {
                context.commit('saveUserRoleFailure', error_data);
            }
        });
    },
    getListRoles(context,payload) {
        const filter_search = payload !="" ? payload : null;

        instance.get(`${API_ENDPOINT_URL}roles`)
        .then(response => {
            context.commit('getRoles',response);
        })
        .catch(error => {
            console.log(error.response);
        });
    },
    removeUserRole(context,payload) {
        const item = payload;
        const item_id = item.id;

        if (item.name !='admin') {
            instance.delete(`${API_ENDPOINT_URL}roles/${item_id}`)
            .then(response => {
                Nprogress.start();
                if (response.status == 204) {
                    context.commit("deleteSuccess",response);
                }
            })
            .catch(error => {
                let error_data = error.response
                if (error_data) {
                    context.commit('deleteFail', error_data);
                }
            });
        } else {
            let error_data = {
                message : 'you cannot to delete this group permission is denined !'
            }
            context.commit('deleteFail', error_data);
        }
    },
    createUser(context,payload) {
        const { input_form } =  payload;

        if (input_form !== null) {
        
            axios.post(`${API_ENDPOINT_URL}users`,{
                access_token : token,
                role: input_form.role,
                firstname: input_form.firstname,
                lastname: input_form.lastname,
                email: input_form.email,
                password: input_form.password,
                status: input_form.status ? 1 : 0
            },{
                headers: {
                    Authorization: 'Bearer '+localStorage.getItem('token')
                }
            })
            .then(response => {
                if (response.status == 201) {
                    Nprogress.start();

                    setTimeout(() => {
                        context.commit('userAddSuccess',response);
                    },1000);
                }
            }).catch(error => {
                let error_data = error.response
                if (error_data) {
                    context.commit('userAddFailure', error_data);
                }
            });
        }
    },
    updateUser(context,payload) {
        const { input_form } =  payload;

        if (input_form !== null) {
            axios.put(`${API_ENDPOINT_URL}users/${input_form.id}`,{
                access_token : token,
                role: input_form.role.id ? input_form.role.id : null,
                firstname: input_form.firstname,
                lastname: input_form.lastname,
                email: input_form.email,
                status: input_form.status ? 1 : 0
            },{
                headers: {
                    Authorization: 'Bearer '+localStorage.getItem('token')
                }
            })
            .then(response => {
                Nprogress.start();
                setTimeout(() => {
                    context.commit('userAddSuccess');
                },1000);
            })
            .catch(error => {
                let error_data = error.response
                if (error_data) {
                    console.log(error_data.message);
                }
            });
        }
    },
    removeUser(context,payload) {
        const item = payload;
        const item_id = item.id;

        axios.delete(`${API_ENDPOINT_URL}users/${item_id}`,{
            headers: {
                Authorization: 'Bearer '+localStorage.getItem('token')
            }
        })
        .then(response => {
            Nprogress.start();
            context.commit("deleteSuccess");
        })
        .catch(error => {
            let error_data = error.response
            if (error_data) {
                console.log(error_data);
            }
        });
    }
}

const mutations = {
    UserRoleSuccess(state, response) {
        Nprogress.done();
        router.push("/admin/setting/users/group");

        Vue.notify({
            group: 'loggedIn',
            type: 'success',
            text: 'User Role Created!'
        });

    },
    saveUserRoleFailure(state, error) {
        Nprogress.done();

        let message ='';
        if (error.status == 500) {
            message = 'This Department Of Active Directory is already exists, please you change another department.';
        } else {
            message = error.message;
        }

        Vue.notify({
            group: 'loggedIn',
            type: 'error',
            text: message
        });
    },
    deleteSuccess(state) {
        Nprogress.done();
        state.delete_status = true;

        let debug = `Delete Status is ${state.delete_status}`;
        console.info(debug);
    },
    deleteFail(state,error) {
        state.delete_status = false;
        Vue.notify({
            group: 'loggedIn',
            type: 'error',
            text: error.message
        });

        let debug = `Delete Status is ${state.delete_status}, because ${error.message}`;
        console.error(debug);
    },
    getRoles(state,response) {
        state.role_status = false;
        state.role_items = response.data.rows;
    },
    userAddSuccess(state,response) {
        Nprogress.done();
        router.push("/admin/setting/users");

        Vue.notify({
            group: 'loggedIn',
            type: 'success',
            text: 'User Created!'
        });
    },
    userAddFailure(state, error) {
        Nprogress.done();

        Vue.notify({
            group: 'loggedIn',
            type: 'error',
            text: error.message
        });
    },
    clearFromDataRole(state) {
        state.name = null;
        state.role_info = {};
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}